import React from 'react';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();
  return (
    <div className="unauth-page">
      <div className="unauth-inner">
        <div className="unauth-icon">⛔</div>
        <h2 className="unauth-title">Access Denied</h2>
        <p className="unauth-sub">You don't have permission to view this page.</p>
        <button className="btn-danger" onClick={() => navigate('/login')}>Back to Login</button>
      </div>
    </div>
  );
};

export default Unauthorized;
